import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaRegEdit } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import useIsNI2 from 'products/nomad_insurance/hooks/useIsNI2';
import Button from 'products/nomad_insurance/components/Button';
import { internalRedirect } from 'helpers';
import PersonalInfoNote from './components/PersonalnfoNote';
import InsuranceSummary from './components/InsuranceSummary';
import PersonalInformation from './components/PersonalInformation';
import { setValidity, setHasProvidedInfo } from './state';
import ApplicantDisplay from '../../components/ApplicantDisplay';
import StepView from '../../components/StepView';
import { Heading, Edit, ApplicantsList, DesktopInfoText } from './styled';
import { useStepNavigationContext } from '../../context';
import { Title, InfoText, NextRow } from '../../styled';
import { PURCHASE_STEP } from '../../consts';
import { trackHubSpotEvent } from '../../utils/hubspot/hubspot-custom-events';

const EditBtn = ({ onClick }) => {
  return (
    <Edit onClick={onClick}>
      <FaRegEdit />
    </Edit>
  );
};

EditBtn.propTypes = {
  onClick: PropTypes.func
};

const Summary = () => {
  const dispatch = useDispatch();
  const { changeStep, jumpToFirstStep, jumpToStep } = useStepNavigationContext();
  const { numberOfDays } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const { isValid } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.applicants
  );
  const { hasProvidedInfo } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.review
  );
  const { planholder, groupMembers } = useSelector(
    (state) => state.nomadInsurance.application
  );

  useEffect(() => {
    if (!isValid) {
      jumpToFirstStep();
    }
  }, [isValid, jumpToFirstStep]);

  useEffect(() => {
    dispatch(setValidity(true));
  }, [dispatch, hasProvidedInfo]);

  const handleNext = () => {
    void trackHubSpotEvent('review', planholder.email);
    changeStep(1);
  };

  return (
    <StepView>
      <Title>Do we have all the correct information?</Title>
      <InfoText>
        Please check that all the information you provided is correct and accurate.
      </InfoText>

      <Heading>
        Insurance summary <EditBtn onClick={() => jumpToStep(PURCHASE_STEP.COVERAGE)} />
      </Heading>
      <DesktopInfoText>Max limit: $250,000</DesktopInfoText>
      <InsuranceSummary />

      {groupMembers?.length > 0 && (
        <>
          <Heading>
            Group members <EditBtn onClick={() => jumpToStep(PURCHASE_STEP.APPLICANTS)} />
          </Heading>
          <ApplicantsList>
            {groupMembers.map((groupMember, index) => (
              <ApplicantDisplay
                key={index}
                color="confetti"
                groupMember={groupMember}
                price={groupMember.totalPrice}
                memberPictureIndex={index}
                homeCountry={planholder.homeCountry}
                contractDuration={numberOfDays}
              />
            ))}
          </ApplicantsList>
        </>
      )}

      <Heading>
        Personal information{' '}
        <EditBtn
          onClick={() => {
            internalRedirect('/dashboard/account');
          }}
        />
      </Heading>
      <InfoText>
        Editing your personal information will re-start your purchase and may impact
        insurance price.
      </InfoText>
      <PersonalInformation />

      <NextRow>
        <Button color="confetti" onClick={handleNext}>
          Move to payment
        </Button>
        <InfoText>Next up, pay for your policy</InfoText>
      </NextRow>
    </StepView>
  );
};

export default Summary;
